import { TextArea as TextAreaGrommet } from 'grommet';
import * as React from 'react';
import { EventHandler } from 'react';

type Props = {
  id: string;
  value: string;
  onChange: EventHandler<any>;
  required?: boolean;
  hasError?: boolean;
};

const TextArea: React.FunctionComponent<Props> = ({ id, value, onChange, required, hasError }: Props) => {
  return (
    <TextAreaGrommet
      name={id}
      value={value}
      onChange={onChange}
      style={required && hasError ? { borderColor: '#b81237', borderWidth: '2px' } : { borderWidth: '2px' }}
    />
  );
};

export default TextArea;
